import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <h1>About Visualize</h1>
      
      <div className="problem-statement">
        <p>
          The US education system has <span className="highlight">failed countless students</span>.
          It remains reliant on textbooks that don't account for different learning styles.
        </p>
        
        <div className="stats-image">
          <img 
            src={process.env.PUBLIC_URL + '/learning-types.png'} 
            alt="Learning Types: Visual 65%, Auditory 30%, Kinesthetic 5%" 
          />
        </div>
      </div>

      <div className="solution">
        <h2>That's where Visualize comes in.</h2>
        <p>
          We are an <span className="highlight">interactive platform</span> that converts text into 
          short form animated videos.
        </p>
        
        <div className="mascot-image">
          <img 
            src={process.env.PUBLIC_URL + '/mascot.png'} 
            alt="Visualize AI Mascot" 
          />
        </div>
      </div>
    </div>
  );
};

export default About; 